import React, { useContext } from 'react';
import { LocalizationContext } from '../../context/localizationContext';
import { fittingRecommendationsContext } from '../../context/fittingRecommendationsContext';
import Button from '../WebfitButton/WebfitButton';
import webfitLogo from '../../assets/logos/WebfitLogoLight.svg';
import Styles from './WebfitTileHeader.module.scss';

const TileHeader = (props) => {
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { buttons } = localizationState.localization;
  const { state } = useContext(fittingRecommendationsContext);
  const { lastUpdatedDate } = state;
  const { onClick } = props;

  const getFormatedDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div className={Styles.header}>
      <div className={Styles.headerText}>
        <div>
          <img src={webfitLogo} alt="WebFit Logo" />
          <div className={Styles.lastFittingDate}>
            Last Fitting: {getFormatedDate(lastUpdatedDate)}
          </div>
        </div>
        <Button
          label={buttons.fitAgain}
          onClick={() => onClick(process.env.REACT_APP_WEBFIT_URL)}
        />
      </div>
    </div>
  );
};

export default TileHeader;
